export default __webpack_public_path__ + "static/media/antifriz.03c7aa43.jpg";